import { Box, Typography, styled } from "@material-ui/core";
import * as React from "react";

import author from "../../images/author.jpg";

const Image = styled("img")(({ theme }) => ({
  width: "90%",
  borderRadius: 8,
  [theme.breakpoints.up("xs")]: {
    width: "90%",
  },
  [theme.breakpoints.up("sm")]: {
    width: 110,
  },
  [theme.breakpoints.up("md")]: {
    width: 220,
  },
  [theme.breakpoints.up("lg")]: {
    width: 220,
  },
}));

export const Author = () => {
  return (
    <Box mt={8} mx={4}>
      <Box maxWidth={1140} marginLeft="auto" marginRight="auto">
        <Box mb={4} mt={2} textAlign="center">
          <Typography variant="h2">The Author</Typography>
        </Box>
        <Box
          display="flex"
          maxWidth={1140}
          flexDirection={{ xs: "column", sm: "row" }}
        >
          <Box flex={0} textAlign="center" mb={{ xs: 4, sm: 0 }}>
            <Image src={author} />
          </Box>
          <Box flex={1} ml={{ xs: 0, sm: 4 }} mt={{ xs: 2, sm: 0 }}>
            <Box mb={2}>
              <Typography variant="body1" color="textPrimary">
                Timo Bozsolik-Torres is a software engineer and data scientist
                who thinks people in tech should be more than nerds with thick
                glasses. Well, at least some of them. As a Google employee, he
                makes the world a smarter place with artificial intelligence. In
                a prior life, he launched two start-ups that didn’t become the
                next unicorn, but who knows, his next idea might be the one.
                <br /> <br />
                His work made Timo realize that data is power and the damage
                that tech companies could do by abusing their market power. He
                wrote THE SCAEVOLA CONSPIRACY to take this issue to the extreme,
                while sharing his own fun and scary experiences with Silicon
                Valley culture. And because sleep is overrated anyway.
                <br /> <br />
                Timo also blogs about the intersection of writing and artificial
                intelligence at{" "}
                <a href="https://quantiwriter.blogspot.com">
                  quantiwriter.blogspot.com
                </a>
                .
                <br /> <br />
                Check out his work on AI-based manuscript assessment at{" "}
                <a href="https://quantifiction.com">quantifiction.com</a>.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/Author/Author.tsx